import {handlePluralMessage} from './handle-plural-message';
import {MessageDescriptor} from './message-descriptor';

export function replaceMessageValue(
  message: string,
  key: string,
  value: unknown,
): string {
  return message.replaceAll(`:${key}`, () => `${value ?? ''}`);
}

export function resolveTranslatedMessage(
  {message, values}: MessageDescriptor,
  lines: Record<string, string> | undefined,
  localeCode: string,
): string {
  if (message == null) return '';
  const owns = (key: string) =>
    lines != null && Object.prototype.hasOwnProperty.call(lines, key);
  const translated = owns(message)
    ? lines![message]
    : owns(message.toLowerCase())
      ? lines![message.toLowerCase()]
      : message;
  return values
    ? handlePluralMessage(localeCode, {message: translated, values})
    : translated;
}
